<nz-card nzTitle="Where Material Is Used">
  <ng-container *ngIf="error$ | async as errorMsg; else resultTpl">
    <em-error-result [subTitle]="errorMsg"></em-error-result>
  </ng-container>
</nz-card>

<ng-template #resultTpl>
  <nz-skeleton [nzActive]="true" [nzLoading]="(designLoading$ | async) ?? false">
    <nz-table
      #materialWhereUsedTable
      [nzData]="(materialWhereUsed$ | async) ?? []"
      [nzLoading]="whereUsedLoading$ | async"
      nzSize="small"
      [nzShowPagination]="true"
      [nzShowSizeChanger]="true"
    >
      <thead>
        <tr>
          <th>Material</th>
          <th>Material Description</th>
          <th>Material Group</th>
          <th>Launch Date</th>
          <th>Market Exit Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let whereUsed of materialWhereUsedTable.data; trackBy: trackByRef">
          <td>
            <a
              [routerLink]="['/data', 'design', whereUsed.material]"
              [queryParams]="{ tab: 'general' }"
              target="_blank"
            >
              {{ whereUsed.material }}
            </a>
          </td>
          <td>{{ whereUsed.description }}</td>
          <td>{{ whereUsed.materialGroup }}</td>
          <td>{{ whereUsed.globalLaunchDate | date: 'shortDate' }}</td>
          <td>{{ whereUsed.marketExitDate | date: 'shortDate' }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-skeleton>
</ng-template>
